export const mapStyleConfig = {
  styleType: 'wnj5nr',
  topLayerGroups: {},
  visibleLayerGroups: {
    label: true,
    road: true,
    water: true,
  },
  threeDBuildingColor: [
    4.179000818945631, 7.370237807958659, 14.816457448989057,
  ],
  mapStyles: {
    wnj5nr: {
      accessToken: '',
      custom: true,
      icon: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/static/-122.3391,37.7922,9,0,0/400x300?access_token=pk.eyJ1IjoidWNmLW1hcGJveCIsImEiOiJja2tyMjNhcWIwc29sMnVzMThoZ3djNXhzIn0._hfBNwCD7pCU7RAMOq6vUQ&logo=false&attribution=false',
      id: 'wnj5nr',
      label: 'Mapbox Satellite Streets',
      url: 'mapbox://styles/mapbox/satellite-streets-v11',
    },
    
  },
};

export const mapStyleHomeConfig = {
  styleType: "light",
  topLayerGroups: {},
  visibleLayerGroups: {
    label: true,
    road: true,
    water: true,
  },
  threeDBuildingColor: [
    4.179000818945631, 7.370237807958659, 14.816457448989057,
  ],
  mapStyles: {
    wnj5nr: {
      accessToken: "",
      custom: true,
      icon: "https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/static/-122.3391,37.7922,9,0,0/400x300?access_token=pk.eyJ1IjoidWNmLW1hcGJveCIsImEiOiJja2tyMjNhcWIwc29sMnVzMThoZ3djNXhzIn0._hfBNwCD7pCU7RAMOq6vUQ&logo=false&attribution=false",
      id: "wnj5nr",
      label: "Mapbox Satellite Streets",
      url: "mapbox://styles/mapbox/satellite-streets-v11",
    },
  },
};
